import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "react-bootstrap";
import { DateTime } from "luxon";
import { Link } from "react-router-dom";
import confirmDelete from "../../components/ConfirmDelete";
import getEncodedImageUrlPres from "../../helpers/getEncodedImageUrlPres";

import MangagePresentations from "./manage-presentation";
import ImgToolTip from "../ImgTooltip";
import TitleTooltip from "../TitleTooltip";
import UploadPresentation from "./upload-pres-ico";

const AddedPresentation = ({
  presentation,
  bgColor,
  room,
  speaker,
  editLink,
  putPresentationMutation,
  deletePresentationMutation,
  putPresentationFileMutation,
  deletePresentationFileMutation,
  intl,
  eventSlug,
  show_video_views,
}) => {
  const [progress, setProgress] = useState(0);
  const [show, setShow] = useState(false);
  const [plays, setPlays] = useState(0);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  let backgroundColor;

  switch (presentation.status) {
    case "no-ppt":
      backgroundColor = "#b3b6ba";
      break;
    case "ppt-uploaded":
      backgroundColor = "#299784";
      break;
    case "recording":
      backgroundColor = "#f9962e";
      break;
    case "video-recorded":
      backgroundColor = "#00ae8f";
      break;
    case "published":
      backgroundColor = "#18be89";
      break;
    default:
      backgroundColor = "red";
      break;
  }

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_HOST}/presentation/${presentation._id}/plays`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}` || "",
          },
        }
      )
      .then((response) => {
        console.log("Play -  id",presentation._id);
        setPlays(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [presentation]);

  return (
    <div className="added-event-container">
      {presentation.status === "published" ? (
        // Insert link here
        <a
          style={{
            background: backgroundColor,
            display: "inherit",
            cursor: "pointer",
          }}
          href={`${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${eventSlug}&presentation_id=${presentation._id}&viewmode=videolanding`}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-presentation btn btn-primary"
        >
          <ImgToolTip
            intl={intl}
            placement="top"
            tooltiptext={`ppt-status.${presentation.status}`}
            id="tooltip-download-latest"
            img={`/images/icon-${presentation.status}-new.svg`}
          />
          {/* <span className="views"><b>1200</b> {intl.formatMessage({id: 'views'})}</span> */}
        </a>
      ) : (
        <Button
          className="btn-presentation"
          style={{ background: backgroundColor }}
        >
          <ImgToolTip
            intl={intl}
            placement="top"
            tooltiptext={`ppt-status.${presentation.status}`}
            id="tooltip-download-latest"
            img={`/images/icon-${presentation.status}-new.svg`}
          />
        </Button>
      )}
      <div className="e-speaker-image">
        {speaker ? (
          speaker.picture ? (
            <img
              className="speaker-image"
              width="110"
              src={getEncodedImageUrlPres(speaker.picture, 150, 150)}
              alt={`${speaker.firstName}${speaker.lastName}`}
            />
            
          ) : (
            <img
              className="speaker-image"
              src={`https://ui-avatars.com/api/?name=${speaker.firstName}${speaker.lastName}&size=110&color=ff7142`}
              alt=""
            />
          )
        ) : (
          <img
            className="speaker-image"
            src={`https://ui-avatars.com/api/?name=NA&size=110&color=ff7142`}
            alt=""
          />
        )}
      </div>
      <div className="e-name-container">
        <div className="e-name">
          <div className="m-l-0">
            {presentation.name.length > 69 ? (
              <TitleTooltip
                title={presentation.name}
                placement="bottom"
                id={presentation._id}
              />
            ) : (
              <h6 style={{width:'166px'}}>{presentation.name}</h6>
            )}
            {/* <pre>{JSON.stringify(speaker, null, 2)}</pre> */}
            <p>
              {speaker
                ? `${speaker.title || ""} ${speaker.firstName} ${
                    speaker.lastName
                  }`
                : ""}
            </p>
            <span>
              <b>
                {/* {intl.formatMessage({ id: "input.presentation.time" })}:{" "} */}
                {presentation.time}{" "}
              </b>{" "}
              {DateTime.fromISO(presentation.date).toFormat("dd/MM/yyyy")}
            </span>
          </div>
        </div>
        {show_video_views ? (
          <div className="plays-count" style = {{ marginLeft:'0px'}}>
            <ImgToolTip
              className="eye-normal"
              intl={intl}
              placement="left"
              tooltiptext={`action.eye-presentation`}
              id="tooltip-eye-latest"
              img={`/icons/eye.svg`}
            />

            <span>{plays}</span>
          </div>
        ) : (
          ""
        )}
        {/* <div className="plays-count">
          <ImgToolTip
            className="eye-normal"
            intl={intl}
            placement="left"
            tooltiptext={`action.eye-presentation`}
            id="tooltip-eye-latest"
            img={`/icons/eye.svg`}
          />

          <span>200</span>
        </div> */}
        <div className="del-event-container">
          <Button
            onClick={() => {
              confirmDelete(
                intl,
                presentation._id,
                presentation.event_id,
                () => deletePresentationMutation({ _id: presentation._id }),
                `${intl.formatMessage({ id: "button.presentation-delete" })}?`
              );
            }}
          >
            <ImgToolTip
              className="icon-normal"
              intl={intl}
              placement="left"
              tooltiptext={`action.delete-presentation`}
              id="tooltip-download-latest"
              img={`/icons/delete.png`}
            />
            <ImgToolTip
              className="icon-hover"
              intl={intl}
              placement="left"
              tooltiptext={`action.delete-presentation`}
              id="tooltip-download-latest-hover"
              img={`/icons/delete-hover.png`}
            />
            <ImgToolTip
              className="icon-focus"
              intl={intl}
              placement="left"
              tooltiptext={`action.delete-presentation`}
              id="tooltip-download-latest-focus"
              img={`/icons/delete-focus.png`}
            />
          </Button>
          <span style={{width:'90px'}}>{room ? room.name : ""}</span>
        </div>
      </div>
      <div className="presentations-cont">
        <div className="ppt-presentations">
          <div className="d-flex">
            <div>
              {presentation.ppt.length > 0 ? (
                <Button
                  onClick={() => handleShow()}
                  className="btn btn-primary up-down"
                >
                  <ImgToolTip
                    intl={intl}
                    placement="right"
                    tooltiptext="tooltip.download.latest"
                    id="tooltip-download-latest"
                    img="/icons/download.png"
                  />
                </Button>
              ) : (
                <Button variant="primary" disabled className="up-down no-dl">
                  <img src="/icons/states/disabled-download.png" alt="" />
                </Button>
              )}
              {/* <Button
                onClick={() => handleShow()}
                variant="primary"
                className="up-down"
              >
                <img
                  src="/icons/upload.png"
                  alt={intl.formatMessage({
                    id: "button.presentation-manage-files",
                  })}
                  title={intl.formatMessage({
                    id: "button.presentation-manage-files",
                  })}
                />
              </Button> */}
              <UploadPresentation
                presentation={presentation}
                progress={progress}
                setProgress={setProgress}
                intl={intl}
                presentationAddFileAction={(_id, file) =>
                  putPresentationFileMutation({ _id, presentation: { file } })
                }
              />
              <MangagePresentations
                show={show}
                handleClose={handleClose}
                presentation={presentation}
                progress={progress}
                setProgress={setProgress}
                intl={intl}
                presentationDeleteFileAction={(_id, file) =>
                  deletePresentationFileMutation({
                    _id,
                    presentation: { file },
                  })
                }
              />
            </div>
            <div className="m-l-20">
              <span>{presentation.ppt.length} version(s)</span>
              <span>
                {presentation.pptSize && presentation.pptSize >= 1
                  ? (presentation.pptSize / 1024 / 1024).toFixed(2)
                  : 0}{" "}
                Mo
              </span>
            </div>
          </div>
        </div>
        <div className="pre-vids m-t-10">
          <span>
            <Button
              onClick={() =>
                putPresentationMutation({
                  _id: presentation._id,
                  presentation: { pdfConvert: !presentation.pdfConvert },
                })
              }
              className={`pre-icon-rounded ${
                !presentation.pdfConvert && "ico-disabled"
              }`}
            >
              <ImgToolTip
                intl={intl}
                placement="top"
                tooltiptext={
                  presentation.pdfConvert
                    ? "disable.pdf.download"
                    : "enable.pdf.download"
                }
                id="tooltip-pdf-convert"
                img={`/icons/states/icon-video_to_pdf-${
                  presentation.pdfConvert ? "dark" : "bright"
                }.svg`}
              />
            </Button>
            <Button
              onClick={() =>
                putPresentationMutation({
                  _id: presentation._id,
                  presentation: { publicVideo: !presentation.publicVideo },
                })
              }
              className={`pre-icon-rounded ${
                !presentation.publicVideo && "ico-disabled"
              }`}
            >
              <ImgToolTip
                intl={intl}
                placement="top"
                tooltiptext={
                  presentation.publicVideo ? "hide.video" : "show.video"
                }
                id="tooltip-pdf-convert"
                img={`/icons/states/ico-show_video-${
                  presentation.publicVideo ? "dark" : "bright"
                }.svg`}
              />
            </Button>
            <Button
              onClick={() =>
                putPresentationMutation({
                  _id: presentation._id,
                  presentation: { public: !presentation.public },
                })
              }
              className={`pre-icon-rounded ${
                !presentation.public && "ico-disabled"
              }`}
            >
              <ImgToolTip
                intl={intl}
                placement="top"
                tooltiptext={
                  presentation.public
                    ? "hide.presentation"
                    : "show.presentation"
                }
                id="tooltip-pdf-convert"
                img={`/icons/states/ico-show_presentation-${
                  presentation.public ? "dark" : "bright"
                }.svg`}
              />
            </Button>
          </span>
        </div>
      </div>
      {/* <Button className="btn-return">{intl.formatMessage({id: 'edit-new'})}</Button> */}
      <Link className="d-flex w-10" to={editLink}>
        <Button className="btn-return">
          {intl.formatMessage({ id: "edit-new" })}
        </Button>
      </Link>
    </div>
  );
};

export default AddedPresentation;
